const _ = "__AI__";
const I = 3e5;
export {
  _ as AI_SUGGESTION_ID,
  I as CONVERSATION_END_THRESHOLD
};
